import { TFunction } from "i18next";

export const validateRequired = (field: string, value: string, t: TFunction): string => {
  if (!value.trim()) {
    switch (field) {
      case "street":
        return `${t("userInfoForm.street")} ${t("userInfoForm.errors.required")}`;
      case "houseNumber":
        return `${t("userInfoForm.houseNumber")} ${t("userInfoForm.errors.required")}`;
      case "postCode":
        return `${t("userInfoForm.postCode")} ${t("userInfoForm.errors.required")}`;
      case "city":
        return `${t("userInfoForm.city")} ${t("userInfoForm.errors.required")}`;
      case "insuranceNumber":
        return `${t("userInfoForm.insuranceNumber")} ${t("userInfoForm.errors.required")}`;
      case "dateOfBirth":
        return `${t("userInfoForm.dateOfBirth")} ${t("userInfoForm.errors.required")}`;
    }
  }
  return "";
};

export const validateFormat = (field: string, value: string, t: TFunction): string => {
  // Only validate format if value is not empty
  if (!value.trim()) return "";

  switch (field) {
    case "houseNumber":
      if (!/^[1-9]\d*$/.test(value)) {
        return `${t("userInfoForm.houseNumber")} ${t("userInfoForm.errors.invalid")}`;
      }
      break;
    case "postCode":
      if (!/^[1-9]\d*$/.test(value)) {
        return `${t("userInfoForm.postCode")} ${t("userInfoForm.errors.invalid")}`;
      }
      break;
    case "insuranceNumber":
      if (!/^[A-Za-z]{4}-\d{2}-\d{7}$/.test(value)) {
        return `${t("userInfoForm.insuranceNumber")} ${t("userInfoForm.errors.invalid")}`;
      }
      break;
    case "dateOfBirth":
      if (!/^[0-3]?\d\.[0-1]?\d\.[0-9]{4}$/.test(value)) {
        return `${t("userInfoForm.dateOfBirth")} ${t("userInfoForm.errors.invalid")}`;
      }
      break;
  }
  return "";
};

// Full validation (for submit validation) - combines both required and format
export const validateField = (field: string, value: string, t: TFunction): string => {
  const requiredError = validateRequired(field, value, t);
  if (requiredError) return requiredError;
  
  return validateFormat(field, value, t);
};
